import ApiService from '../../../../services/ApiService'

export default {
  data: () => ({
    isEditing: false,
    applyRules: true,
    alterDialog: false,
    changedData: false,
    confirmDialog: false,
    loading: false,
    calibrationMetricsLoading: false,
    showSuccess: false,
    error: false,
    errorMessage: '',
    message: '',
    calibrationMetricsId: 0,
    calibrationMetricsArray: [],
    currentCalibrationMetrics: {
      id: 0,
      name: '',
      unit: '',
    },
    apiService: new ApiService(),
  }),

  async created() {
    this.calibrationMetricsLoading = true
    this.searchCalibrationMetrics()
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.alterDialog = false
      this.close()
    },

    callConfirmDialog() {
      if (this.isEditing && this.$refs.firstForm.validate()) {
        this.confirmDialog = true
      } else {
        this.submit()
      }
    },

    showSuccessAlert(message) {
      this.message = message
      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 1000)
    },

    async searchCalibrationMetrics() {
      await this.apiService.get('calibrationMetrics/list').then((response) => {
        this.calibrationMetricsArray = response.content
        this.calibrationMetricsArray.unshift({
          id: 0,
          name: 'Nova métrica',
          unit: '',
        })
        this.calibrationMetricsLoading = false
      })
    },

    selectedCalibrationMetrics() {
      const calibrationMetrics = this.calibrationMetricsArray.find(
        (calibration) => calibration.id === this.calibrationMetricsId
      )

      if (calibrationMetrics.id > 0) {
        this.isEditing = true
        this.currentCalibrationMetrics = calibrationMetrics
        this.applyRules = true
      } else {
        this.currentCalibrationMetrics = new Object()
        this.isEditing = false
      }
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true
        this.confirmDialog = false

        const calibrationMetrics = {
          Id: this.currentCalibrationMetrics.id,
          Name: this.currentCalibrationMetrics.name,
          Unit: this.currentCalibrationMetrics.unit,
        }

        let url = 'calibrationMetrics/add'

        if (this.isEditing) {
          url = 'calibrationMetrics/edit'
        }

        await this.apiService
          .post(url, calibrationMetrics)
          .then((response) => {
            this.applyRules = false
            this.calibrationMetricsId = 0
            this.currentCalibrationMetrics.id = 0
            this.currentCalibrationMetrics.name = ''
            this.currentCalibrationMetrics.unit = ''
            this.loading = false
            this.searchCalibrationMetrics()
            this.showSuccessAlert(response.message)
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

        this.isEditing = false
        this.applyRules = true
      }
    },
  },

  computed: {
    buttonText() {
      if (this.isEditing) {
        return 'Atualizar'
      } else {
        return 'Adicionar'
      }
    },
  },

  watch: {
    currentCalibrationMetrics: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
